import { defineComponent as _defineComponent } from 'vue'
import * as TireQuantityHelper from 'Src/js/helpers/TireQuantityHelper';
import ChangeStoreSideMenu from 'JS/components/side-menus/change-store/ChangeStoreSideMenu.vue';
import Icon from 'JS/components/Icon.vue';
import InstallationQuoteSidebar from 'JS/pdp/components/automotive/quote/InstallationQuoteSidebar.vue';
import QuantityField from 'Src/js/components/QuantityField.vue';
import { computed, ref, watch } from 'vue';
import { ILocalStoreJson } from 'JS/types/LocalStore';
import { IProductDetailProductJson } from 'JS/types/PDP';
import { PDPRootState } from 'JS/pdp/state/types';
import { useLegacyVuexStore } from 'JS/composables/legacy-vuex-store';


export default /*#__PURE__*/_defineComponent({
  __name: 'AutoStockInfo',
  setup(__props) {

const vuexStore = useLegacyVuexStore<PDPRootState>();
const showChangeStore = ref(false);
const showInstallationQuoteSidebar = ref(false);
const currentZip = ref<string>(vuexStore.state.currentZip);
const showFitmentWarning = ref(false);

const product = computed<IProductDetailProductJson>(() => vuexStore.state.product);
const store = computed<ILocalStoreJson>(() => vuexStore.state.localStore);

const quantity = computed<number>({
	get: () => {
		return vuexStore.state.quantity;
	},
	set: (val) => {
		vuexStore.commit('quantity', val);
	}
});

const minBuyableQty = computed(() => vuexStore.getters.minBuyableQty as number);
const hasSelectedVariant = computed(() => vuexStore.getters.hasSelectedVariant as boolean);

const outOfStock = computed(() => product.value.isTire
	? TireQuantityHelper.getOutOfStock(product.value)
	: product.value.inStoreStock <= 0);
const productQuantityCurrentlyInStock = computed(() => !product.value.isTire && product.value.inStoreStock >= quantity.value);
const amountAvailable = computed(() => product.value.isTire
	? TireQuantityHelper.getAmountAvailable(product.value)
	: Math.max(0, product.value.inStoreStock));

const maxQuantityExceeded = computed(() => product.value.isTire
	? TireQuantityHelper.getMaxQuantityExceeded(product.value, quantity.value)
	: product.value.inStoreStock < quantity.value);

const showOnlyXLeft = computed(() => product.value.isTire
	? maxQuantityExceeded.value
	: !outOfStock.value && product.value.inStoreStock < 10);

const nextAvailableDate = computed(() => TireQuantityHelper.getNextAvailableDate(product.value, quantity.value));

const stockContainerStateClass = computed(() => {
	if (product.value.stockUnavailableMessage) {
		return 'stock-unavailable';
	}

	if (productQuantityCurrentlyInStock.value && !maxQuantityExceeded.value) {
		// TODO future improvement (BFF-925): battery quantity cannot be changed here. show the in stock state.
		// should go along with improvement to make the quantity reset to 1 when changing from install
		// it myself to install it for me. See ProductDetailsApp.vue for related TODO
		if (product.value.inStoreStock >= 10) {
			return "in-stock";
		}
		return "low-stock";
	}

	if (outOfStock.value || maxQuantityExceeded.value) {
		return "sold-out";
	}

	return "low-stock";
});

const fitmentWarning = computed((): string => {
	if (!product.value.vehicleFitment) {
		return "Add a vehicle ";
	}

	if (!product.value.vehicleFitment.fits) {
		let productString = " this product";
		if (product.value.isTire) {
			productString = " these tires";
		} else if (product.value.isAutomotiveBattery) {
			productString = " this battery";
		}

		return "Add a vehicle" + productString + " will fit ";
	}

	return "";
});

watch(() => product.value?.vehicleFitment, () => {
	showFitmentWarning.value = false;
});

function handleViewInstallationClick() {
	showFitmentWarning.value = false;
	if (product.value.vehicleFitment?.fits) {
		showInstallationQuoteSidebar.value = true;
		sendGtmEvent('auto_installation_quote');
	} else {
		showFitmentWarning.value = true;
		sendGtmEvent('auto_fitment_warning');
	}
}

function sendGtmEvent(eventName: String) {
	window.blainGtmDataLayer.push({
		'automotiveEvent': eventName,
		'event': "automotive_event"
	});
}

return { __sfc: true,vuexStore, showChangeStore, showInstallationQuoteSidebar, currentZip, showFitmentWarning, product, store, quantity, minBuyableQty, hasSelectedVariant, outOfStock, productQuantityCurrentlyInStock, amountAvailable, maxQuantityExceeded, showOnlyXLeft, nextAvailableDate, stockContainerStateClass, fitmentWarning, handleViewInstallationClick, sendGtmEvent, ChangeStoreSideMenu, Icon, InstallationQuoteSidebar, QuantityField }
}

})